import { render } from "./MainContainer.vue?vue&type=template&id=24991fae&scoped=true"
const script = {}

import "./MainContainer.vue?vue&type=style&index=0&id=24991fae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24991fae"]])

export default __exports__